import React from 'react';
import Lottie from 'lottie-react';
import bunnyAnimation from '../assets/animations/bunny.json';
import { useMediaQuery } from 'react-responsive';
import { constantStyles } from '../constants/constantStyles';

const LoadingScreen = () => {

    const isMobile = useMediaQuery({ maxWidth: constantStyles.mobileWidth });

    const size = isMobile ? 100 : 150;

    return (
      <div className="flex items-center justify-center h-screen bg-white">
        <Lottie
          animationData={bunnyAnimation}
          loop={true}
          style={{ width: size, height: size }}
        />
      </div>
    );
  };

export default LoadingScreen;